(() => {
  const STORAGE_KEY = 'belties_recently_viewed_v1';
  const MAX_STORED = 12;

  const readHistory = () => {
    try {
      const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (_error) {
      return [];
    }
  };

  const writeHistory = (items) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, MAX_STORED)));
    } catch (_error) {
      // Browsing history is optional; the storefront remains usable when storage is unavailable.
    }
  };

  const parseCurrentProduct = (root) => {
    try {
      return JSON.parse(root.querySelector('[data-bt-current-product]')?.textContent || 'null');
    } catch (_error) {
      return null;
    }
  };

  const addText = (parent, tag, className, text) => {
    const node = document.createElement(tag);
    node.className = className;
    node.textContent = text;
    parent.append(node);
    return node;
  };

  if (!customElements.get('bt-recently-viewed')) {
    class BtRecentlyViewed extends HTMLElement {
      connectedCallback() {
        const current = parseCurrentProduct(this);
        let history = readHistory();

        if (current?.handle) {
          history = [current, ...history.filter((item) => item?.handle !== current.handle)];
          writeHistory(history);
        }

        const currentHandle = current?.handle || this.dataset.currentHandle || '';
        const limit = Number(this.dataset.limit || 8);
        const items = history.filter((item) => item?.handle && item.handle !== currentHandle).slice(0, limit);
        if (!items.length) return;

        const track = this.querySelector('[data-bt-recently-viewed-track]');
        if (!track) return;

        const formatter = new Intl.NumberFormat(this.dataset.locale || 'ja-JP', {
          style: 'currency',
          currency: this.dataset.currency || 'JPY',
          maximumFractionDigits: 0,
        });

        items.forEach((item) => {
          const card = document.createElement('article');
          card.className = 'bt-recently-viewed__card';

          const media = document.createElement('a');
          media.className = 'bt-recently-viewed__media';
          media.href = item.url;
          const image = document.createElement('img');
          image.className = 'bt-recently-viewed__image';
          image.src = item.image;
          image.alt = item.title;
          image.loading = 'lazy';
          media.append(image);
          if (Number(item.compareAt) > Number(item.price)) addText(media, 'span', 'bt-recently-viewed__badge', 'SALE');
          card.append(media);

          const title = addText(card, 'a', 'bt-recently-viewed__title', item.title);
          title.href = item.url;

          const priceRow = document.createElement('div');
          priceRow.className = 'bt-recently-viewed__price-row';
          if (Number(item.compareAt) > Number(item.price)) {
            addText(priceRow, 'span', 'bt-recently-viewed__compare', formatter.format(Number(item.compareAt) / 100));
          }
          addText(
            priceRow,
            'strong',
            `bt-recently-viewed__price${Number(item.compareAt) > Number(item.price) ? ' bt-recently-viewed__price--sale' : ''}`,
            formatter.format(Number(item.price) / 100)
          );
          card.append(priceRow);
          track.append(card);
        });

        this.hidden = false;
      }
    }

    customElements.define('bt-recently-viewed', BtRecentlyViewed);
  }
})();
